export default [
  { value: '', text: 'Select location' },
  { value: 'aerator', text: 'Shallow Near Aerator' },
  { value: 'shore', text: 'Shallow Near Shore' },
  { value: 'deep', text: 'Deep Sample' },
  { value: 'drain', text: 'Drain End' },
  { value: 'other', text: 'Other' },
];
